import styled from "styled-components"

export const ListCourseStyle = styled.div`
  padding: 0 0 24px 0;
  .title-list {
    text-transform: uppercase;
    font-weight: 600;
    font-size: 16px;
  }
  .box-white {
    background: #fff;
    border-radius: 8px;
    width: 100%;
    padding: 16px;
  }
`
